var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageDefIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.75rem",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 11.3332H2.66667C1.196 11.3332 0 12.5292 0 13.9998V24.6665C0 26.1372 1.196 27.3332 2.66667 27.3332H21.3333C22.804 27.3332 24 26.1372 24 24.6665V13.9998C24 12.5292 22.804 11.3332 21.3333 11.3332ZM2.66667 24.6665V13.9998H21.3333L21.336 24.6665H2.66667ZM2.66667 5.99984H21.3333V8.6665H2.66667V5.99984ZM5.33333 0.666504H18.6667V3.33317H5.33333V0.666504Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDefIcon);
export default __webpack_public_path__ + "static/media/messageDefIcon.d14e084280f7255cc96906a132bc9f00.svg";
export { ForwardRef as ReactComponent };